//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import QuestionList from "./components/questionList";
import QuestionAnswerList from "./components/question-answer-list";

export default {
    name: "question",
    components: {
        QuestionAnswerList,
        QuestionList,
        BottomNav,
    },
    data() {
        return {
            active: 0,
            qstList: [
                {
                    tit: '武汉中粮光谷祥云问卷调查',
                    dec: '赠送20积分'
                },
                {
                    tit: '长沙中粮鸿云问卷调查',
                    dec: '赠送20积分'
                }
            ],
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            list: []
        }
    },
    methods: {
        getPage() {
            let page = {
                // name: payload.data.name,
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            };
            abp.ajax.post('/api/services/app/Questionnaire/SearchQuestionnaires', page).then(res => {
                this.list = [];
                this.list.push(...rep.data.result.items);
                this.totalCount = rep.data.result.totalCount;
            })

        }
    },
    created() {
        // this.getPage()
    }
}
